import { SwmsQueryParams } from '@/modules/swms/constants'
import { Params, stringifyUrl } from '@/utils/params'

export const extraRoutes = {
  _404: '/404',
  account: {
    details: '/account/settings',
    cheatsheet: '/account/cheatsheet',
    inbox: '/account/inbox',
    notificationSettings: '/account/preferences',
  },
  swmsLibrary: {
    new: () => `/documents/swms-library/new`,
    list: (params?: Params.SwmsLibraryList) =>
      stringifyUrl('/documents/swms', {
        ...params,
        ...({ tab: 'SwmsLibrary' } as SwmsQueryParams),
      }),
    view: (swmsDocId: string) => `/documents/swms-library/${swmsDocId}`,
  },
}
